// extracted by mini-css-extract-plugin
module.exports = {"container-card-option-onbording":"classes_container-card-option-onbording__34MD3"};